function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4D5477",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11 0C7.316 0 6.647 1.039 6.531 1.36c-.013.036-.026.082-.03.12l-.553 4.872c.733-.32 1.736-.278 3.034-.21.604.032 1.288.075 2.018.075.729 0 1.414-.043 2.018-.074 1.296-.07 2.301-.11 3.034.209l-.553-4.872c-.004-.038-.017-.084-.03-.12C15.353 1.04 14.682 0 11 0zm-.478 1.913h.956v1.435h1.435v.956h-1.435V5.74h-.956V4.304H9.087v-.956h1.435V1.913zM7.966 7.054c-.897-.026-1.584.032-1.913.344-.215.206-.314.572-.314 1.121 0 2.901 2.36 5.26 5.261 5.26 2.901 0 5.26-2.359 5.26-5.26 0-.55-.098-.915-.313-1.12-.437-.416-1.523-.37-2.884-.3-.615.032-1.308.075-2.063.075-.755 0-1.448-.043-2.063-.075-.34-.018-.672-.035-.971-.045zM11 14.258c-1.072 0-2.14.097-3.154.284L11 22.194l3.198-7.637c-1.03-.194-2.107-.299-3.198-.299zm-4.095.493C3.013 15.697 0 17.861 0 20.131v3.782h11c-.192 0-.376-.12-.448-.299l-3.647-8.863zM11 23.913h11v-3.781c0-2.259-2.98-4.428-6.845-5.38l-3.707 8.862c-.074.178-.256.299-.448.299z",
  transform: "translate(-23 -364) translate(23 364)"
}))));

var SvgClinicMembers = function SvgClinicMembers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinicMembers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinic-members.8fdc97d2.svg";
export { ForwardRef as ReactComponent };